var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sparkline"},[_c('e-chart',{staticStyle:{"width":"90%","max-width":"90%","min-height":"90%","max-height":"90%"},attrs:{"option":_vm.config,"autoresize":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }